import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/document-request-users/{id}/files']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const createDocumentRequestUserFile = async ({
  id,
  isRequired,
  isForYourEyesOnly,
  title,
  description,
  metadata,
}: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.post(`/document-request-users/${id}/files`, {
    description,
    isForYourEyesOnly,
    isRequired,
    metadata,
    title,
  });
  return response.data;
};

export default createDocumentRequestUserFile;
